import { useRef, useImperativeHandle, forwardRef, useMemo } from 'react';
import { Stage, Layer } from 'react-konva';
import DraggableImage from './DraggableImage';
import type { AvatarComposition } from '../types/types';
import { useEffect } from 'react';

interface AvatarCanvasProps {
  avatarComposition: AvatarComposition;
  onItemDragEnd: (id: string, newPos: { x: number; y: number }) => void;
}

export interface AvatarCanvasRef {
  getStage: () => unknown;
}

const AvatarCanvas = forwardRef<AvatarCanvasRef, AvatarCanvasProps>(
  ({ avatarComposition, onItemDragEnd }, ref) => {
    const stageRef = useRef<unknown>(null);
    const layerRef = useRef<unknown>(null);
    const canvasWidth = 450;  
    const canvasHeight = 600; 
    const scaleForIframe = 0.60; 

    
    useImperativeHandle(ref, () => ({
      getStage: () => stageRef.current,
    }));

    
    

    const sortedItems = useMemo(() => {
      return [...avatarComposition].sort((a, b) => a.zIndex - b.zIndex);
    }, [avatarComposition]);

    
    useEffect(() => {
          }, [sortedItems]);
    
    
    useEffect(() => {
      if (layerRef.current) {
        const layer = layerRef.current as any;
        
        const children = layer.getChildren();
        children.sort((a: any, b: any) => {
          const zIndexA = a.getAttr('zIndex') || 0;
          const zIndexB = b.getAttr('zIndex') || 0;
          return zIndexA - zIndexB;
        });
        layer.batchDraw();
      }
    }, [avatarComposition]);

    return (
      <div className="canvas-container">
        <div className="avatar-display">
          <Stage 
            width={canvasWidth * scaleForIframe} 
            height={canvasHeight * scaleForIframe} 
            scaleX={scaleForIframe} 
            scaleY={scaleForIframe} 
            
            ref={stageRef as any}
          >
            <Layer ref={layerRef as any}>
              {sortedItems.map((item) => (
                <DraggableImage
                  key={item.id}
                  item={item}
                  onDragEnd={onItemDragEnd}
                />
              ))}
            </Layer>
          </Stage>
        </div>
      </div>
    );
  }
);

AvatarCanvas.displayName = 'AvatarCanvas';

export default AvatarCanvas;
